import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Select from "../../../../design-system/components/Form/Select/Select";
import MenuItem from '@material-ui/core/MenuItem';

import { commonModuleStyles } from '../../../../assets/styles/jss/pages/common/CommonModuleStyles';
// @sdk
import {MembershipManagmentB2BService} from '@sdk-point/talisis';

//se crea la variable para el llamado
const MembershipManagmentB2BServiceSDK = new MembershipManagmentB2BService(process.env.REACT_APP_ENV_V2, process.env.REACT_APP_X_API_KEY_V2);


const FormUsers = (props) => {
    const { onChange, data, error, handleAddUser, handleVerifyEmail, period, program, attribute, dataprincipal, disabledAddon, disabledAdd, membership, addon , groupOptions, onAttributeClick} = props;
    const classes = commonModuleStyles();
    const theme = useTheme();
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState({});
    const [form, setForm] = React.useState({});

    const [nameWarning, setNameWarning] = useState('');

    const handleChange = async (e) => {
        let { name, value } = e.target;

        if (value) {
            const _errors = { ...errors };
            delete _errors[name];

            setErrors(_errors);
        }

        setForm(prev => { return { ...prev, [name]: value } });
    };

    const handleVerifyName = async () => {
        if (!data.name || !data.lastNamePaternal) return;
        setNameWarning('');
        try {
            // TODO: Replace with actual backend endpoint for name+apellidos verification
            // Endpoint not yet available. When backend implements GET /b2b/students/search?name=X&lastName=Y,
            // uncomment and use:
            // const fullName = `${data.name} ${data.lastNamePaternal} ${data.lastNameMaternal || ''}`.trim();
            // const response = await MembershipManagmentB2BServiceSDK.searchStudents({ name: data.name, lastName: `${data.lastNamePaternal} ${data.lastNameMaternal || ''}`.trim() });
            // if (response.data && response.data.length > 0) {
            //     setNameWarning('La combinación de Nombre + Apellidos ya existe en el sistema.');
            // }
            console.warn('[FormUsers] Verificación de nombre+apellidos: endpoint pendiente de implementación backend');
        } catch (error) {
            console.error('[FormUsers] Error verificando nombre:', error);
        }
    };


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography color={"primary"} variant={'h6'} className={classes.sectionTitle} style={{ paddingBottom: 8, borderBottom: `1px solid ${theme.palette.colors?.fillStroke?.[200] || '#E0E0E0'}` }}>
                    Información del usuario
                </Typography>
            </Grid>
            <Grid item xs={12} className={classes.sectionContainer}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            required
                            margin="dense"
                            variant="outlined"
                            label="Nombre"
                            fullWidth
                            name="name"
                            value={data.name}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => onChange(e)}
                            error={Boolean(error.name)}
                            helperText={error.name}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            required
                            margin="dense"
                            variant="outlined"
                            label="Apellido Paterno"
                            fullWidth
                            name="lastNamePaternal"
                            value={data.lastNamePaternal}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => onChange(e)}
                            error={Boolean(error.lastNamePaternal)}
                            helperText={error.lastNamePaternal}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            required
                            margin="dense"
                            variant="outlined"
                            label="Apellido Materno"
                            fullWidth
                            name="lastNameMaternal"
                            value={data.lastNameMaternal}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => onChange(e)}
                            onBlur={handleVerifyName}
                            error={Boolean(error.lastNameMaternal)}
                            helperText={error.lastNameMaternal || nameWarning}
                            FormHelperTextProps={nameWarning ? { style: { color: '#f57c00' } } : {}}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField
                            required
                            margin="dense"
                            variant="outlined"
                            label="Correo"
                            fullWidth
                            name="email"
                            value={data.email}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onBlur={(e)=> handleVerifyEmail(e)}
                            onChange={(e) => onChange(e)}
                            error={Boolean(error.email)}
                            helperText={error.email}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Select
                            required
                            items= {membership}
                            label="Membresias"
                            name="membership"
                            value={data.membership}
                            onClick={e => e.stopPropagation()}
                            onChange={(e) => onChange(e)}
                            size="large"
                            margin="dense"
                            error={Boolean(error.membership)}
                            helperText={error.membership}
                        />

                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Select
                            items={period}
                            label="Plazo"
                            name="time"
                            value={data.time}
                            onClick={e => e.stopPropagation()}
                            onChange={(e) => onChange(e)}
                            size="large"
                            margin="dense"
                            error={Boolean(error.time)}
                            helperText={error.time}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Select
                            items={program}
                            label="Programa"
                            name="program"
                            value={data.program}
                            onClick={e => e.stopPropagation()}
                            onChange={(e) => onChange(e)}
                            size="large"
                            margin="dense"
                            error={Boolean(error.program)}
                            helperText={error.program}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Select
                            items= {addon}
                            label="Addon"
                            name="addon"
                            value={data.addon}
                            onClick={e => e.stopPropagation()}
                            onChange={(e) => onChange(e)}
                            size="large"
                            margin="dense"
                            error={Boolean(error.addon)}
                            helperText={error.addon}
                            disabled={disabledAddon}
                        />

                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} className={classes.formRow}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography color={"primary"} variant={'h6'} className={classes.sectionTitle} style={{ paddingBottom: 8, borderBottom: `1px solid ${theme.palette.colors?.fillStroke?.[200] || '#E0E0E0'}` }}>
                            Atributos personalizados
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.sectionContainer}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                {dataprincipal.group && dataprincipal.group.label ? (
                                    <TextField
                                        disabled
                                        margin="dense"
                                        variant="outlined"
                                        label="Grupo"
                                        fullWidth
                                        name="group"
                                        value={dataprincipal.group.label}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(e) => onChange(e)}
                                        error={Boolean(error.group)}
                                        helperText={error.group}
                                    />
                                ) : (

                                    <Select
                                        items={groupOptions}
                                        label="Grupo"
                                        name="group"
                                        value={data.group}
                                        onClick={e => e.stopPropagation()}
                                        onChange={(e) => onChange(e)}
                                        size="large"
                                        margin="dense"
                                        error={Boolean(error.group)}
                                        helperText={error.group}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    name="attribute1"
                                    label="Atributo 1"
                                    select
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    value={data.attribute1}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => onChange(e)}
                                    error={Boolean(error.attribute1)}
                                    helperText={error.attribute1}
                                >
                                    <MenuItem value="" disabled><em>Seleccione</em></MenuItem>
                                    {attribute.map(option => (
                                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                                    ))}
                                    <Box p={1}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (onAttributeClick) onAttributeClick('attribute1');
                                            }}
                                        >
                                            Nuevo Atributo
                                        </Button>
                                    </Box>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    name="attribute2"
                                    label="Atributo 2"
                                    select
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    value={data.attribute2}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => onChange(e)}
                                    error={Boolean(error.attribute2)}
                                    helperText={error.attribute2}
                                >
                                    <MenuItem value="" disabled><em>Seleccione</em></MenuItem>
                                    {attribute.map(option => (
                                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                                    ))}
                                    <Box p={1}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (onAttributeClick) onAttributeClick('attribute2');
                                            }}
                                        >
                                            Nuevo Atributo
                                        </Button>
                                    </Box>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    name="attribute3"
                                    label="Atributo 3"
                                    select
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    value={data.attribute3}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => onChange(e)}
                                    error={Boolean(error.attribute3)}
                                    helperText={error.attribute3}
                                >
                                    <MenuItem value="" disabled><em>Seleccione</em></MenuItem>
                                    {attribute.map(option => (
                                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                                    ))}
                                    <Box p={1}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (onAttributeClick) onAttributeClick('attribute3');
                                            }}
                                        >
                                            Nuevo Atributo
                                        </Button>
                                    </Box>
                                </TextField>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Box className={classes.sectionDivider}>
                    <Button 
                        variant="contained"
                        color="primary"
                        startIcon={<AddIcon />}
                        onClick={handleAddUser}
                        disabled={disabledAdd}
                        size="large"
                    >
                        Añadir usuario
                    </Button>
                </Box>
            </Grid>
        </Grid>
    )
}

export default FormUsers
